import { format, formatDistanceToNow, parseISO } from 'date-fns';

/** Compact, locale-aware number (1,234 or 12.3K). */
export function formatNumber(value: number, compact = false): string {
  return new Intl.NumberFormat(undefined, {
    notation: compact ? 'compact' : 'standard',
    maximumFractionDigits: compact ? 1 : 0,
  }).format(value);
}

/** Human-readable byte size. */
export function formatBytes(bytes: number): string {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

function toDate(value: string | number | Date): Date {
  if (value instanceof Date) return value;
  if (typeof value === 'number') return new Date(value);
  return value.includes('T') ? parseISO(value) : new Date(value);
}

/** Format a date value; returns em dash for missing/invalid input. */
export function formatDate(value?: string | number | Date | null, pattern = 'PP'): string {
  if (!value) return '—';
  const date = toDate(value);
  return Number.isNaN(date.getTime()) ? '—' : format(date, pattern);
}

/** Relative time such as "3 hours ago". */
export function formatRelative(value?: string | number | Date | null): string {
  if (!value) return '—';
  const date = toDate(value);
  return Number.isNaN(date.getTime()) ? '—' : `${formatDistanceToNow(date)} ago`;
}

/** Turn a snake/kebab identifier into a Title Case label. */
export function humanize(value: string): string {
  return value.replace(/[_-]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
